module.exports = __webpack_public_path__ + "static/media/linkdin.97ce31c8.svg";